import React, { Component } from 'react'
import {connect} from 'react-redux';
// utils
import {Translations} from '../../utils';
// restClient
import { aemHostClient} from '../../restClient';
// children
import AdminPanel from './AdminPanel/AdminPanel';
//action Creator
import {setDarkTitleBarContent} from '../layouts/actions/actionCreator';
import {setUserAdminDetail, setGroupAdminDetail, setCustomerAdminDetail} from './actions/actionCreator';
import {setAdminTabIndex} from './actions/actionCreator';

class Admin extends Component {

  state = {darkTitleBarJson: undefined}
  componentWillMount () {
      aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({data}) => {
          this.setState({darkTitleBarJson: data.par});
          this.props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.admin, this.props.lang.currentLang.lang, this.props.lang.translatedData));
      });
  }

  render(){
    return ((this.state.darkTitleBarJson !== undefined) ?
      <div className="admin-container">
        <AdminPanel
          history={this.props.history}
          setUserAdminDetail={(data) => this.props.setUserAdminDetail(data)}
          setGroupAdminDetail={(data) => this.props.setGroupAdminDetail(data)}
          setCustomerAdminDetail={(data) => this.props.setCustomerAdminDetail(data)}
          adminTabIndex = {(index) => this.props.setAdminTabIndex(index)}
          activeTabIndex ={this.props.activeTabIndex}
          darkTitleBarJson = {this.state.darkTitleBarJson}
          lang={this.props.lang}
        />
      </div>
        : '');
  }
}

const mapStateToProps = state => {
  return {
    activeTabIndex: state.adminPanelTabReducer,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    setUserAdminDetail: data => {
      dispatch(setUserAdminDetail(data))
    },
    setGroupAdminDetail: data =>{
      dispatch(setGroupAdminDetail(data))
    },
    setCustomerAdminDetail: data => {
      dispatch(setCustomerAdminDetail(data))
    },
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Admin)



// WEBPACK FOOTER //
// ./src/components/Admin/index.js